var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class DepartmentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DepartmentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], DepartmentDTO.prototype, "positionIds", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DepartmentDTO.prototype, "color", void 0);
export class DepartmentStructureDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentStructureDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DepartmentStructureDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentStructureDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], DepartmentStructureDTO.prototype, "positions", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DepartmentStructureDTO.prototype, "order", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DepartmentStructureDTO.prototype, "color", void 0);
//# sourceMappingURL=department.dto.js.map